<div class="reschedule-drawer">
  <!-- Header with service info -->
  <div class="service-info">
    <nz-tag nzColor="blue">{{ data.service?.name }}</nz-tag>
    <nz-tag nzColor="orange">{{ data.serviceDuration }} წთ</nz-tag>
  </div>

  <!-- Employee selector -->
  <div class="employee-selector">
    <beautyapp-select
      [(ngModel)]="selectedEmployeeId"
      (ngModelChange)="changeEmployee($event)"
      [data]="employees()"
      label="თანამშრომელი"
      placeholder="აირჩიეთ თანამშრომელი"
      valueMember="id"
      displayMember="fullName"
    ></beautyapp-select>
  </div>

  <!-- Calendar controls -->
  <div class="calendar-controls">
    <div class="date-controls">
      <beautyapp-datepicker
        [(ngModel)]="currentDate"
        (ngModelChange)="changeDate($event)"
        [allowClear]="false"
      ></beautyapp-datepicker>
      <div class="nav-buttons">
        <button nz-button nzType="default" (click)="prevDate()">
          <span nz-icon nzType="left"></span>
        </button>
        <button nz-button nzType="default" (click)="todayDate()">
          <span nz-icon nzType="carry-out"></span>
        </button>
        <button nz-button nzType="default" (click)="nextDate()">
          <span nz-icon nzType="right"></span>
        </button>
      </div>
    </div>

    <div class="interval-buttons">
      <nz-space>
        <button *nzSpaceItem nz-button
          [nzType]="timeInterval === '00:05:00' ? 'primary' : 'default'"
          (click)="changeTimeInterval('00:05:00')">
          5 წთ
        </button>
        <button *nzSpaceItem nz-button
          [nzType]="timeInterval === '00:15:00' ? 'primary' : 'default'"
          (click)="changeTimeInterval('00:15:00')">
          15 წთ
        </button>
        <button *nzSpaceItem nz-button
          [nzType]="timeInterval === '00:30:00' ? 'primary' : 'default'"
          (click)="changeTimeInterval('00:30:00')">
          30 წთ
        </button>
        <button *nzSpaceItem nz-button
          [nzType]="timeInterval === '01:00:00' ? 'primary' : 'default'"
          (click)="changeTimeInterval('01:00:00')">
          1 სთ
        </button>
      </nz-space>
    </div>
  </div>

  <!-- Selected slot info -->
  @if (selectedSlot()) {
    <nz-alert
      nzType="success"
      [nzMessage]="'არჩეული დრო: ' + (selectedSlot()!.start | date:'dd/MM/yyyy HH:mm') + ' - ' + (selectedSlot()!.end | date:'HH:mm')"
      nzShowIcon
    ></nz-alert>
  } @else {
    <nz-alert
      nzType="info"
      nzMessage="აირჩიეთ სასურველი დრო კალენდარზე დაკლიკებით"
      nzShowIcon
    ></nz-alert>
  }

  <!-- Calendar -->
  <div class="calendar-container">
    <full-calendar #calendar [options]="calendarOptions">
      <ng-template #eventContent let-event>
        <div class="fc-event-content">
          {{ event.event.title }}
        </div>
      </ng-template>
    </full-calendar>
  </div>

  <!-- Footer actions -->
  <div class="drawer-footer">
    <button nz-button nzType="default" (click)="cancel()">
      {{ 'buttons.cancel' | translate }}
    </button>
    <button nz-button nzType="primary"
      [nzLoading]="loading()"
      [disabled]="!selectedSlot()"
      (click)="saveReschedule()">
      {{ 'buttons.save' | translate }}
    </button>
  </div>
</div>
